// extracted by mini-css-extract-plugin
export default {"linkTreeContainer":"linktree_linkTreeContainer__HQgWF","logo":"linktree_logo__OJw6r"};